import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import get from "lodash.get";

import { selectDropDownStates } from "selector/initializeSelector";
import {
  changeWorklistFilter,
  changeFilterInput
} from "actions/fetchWorkItemsActions";
import HomeWorkListStateDropdown from "components/home/WorkList/StateDropdown";
import { selectStateFilterInput } from "selector/workItemSelectors";

const mapStateToProps = (state, ownProps) => {
  return {
    items: selectDropDownStates(state),
    inputValue: selectStateFilterInput(state),
    ...ownProps
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      onSelection: selection =>
        changeWorklistFilter({
          name: "state",
          value: get(selection, "value", null)
        }),
      onInputValueChange: value => {
        if (value !== "") {
          return changeFilterInput("state", value);
        } else {
          dispatch(changeFilterInput("state", value));
          return changeWorklistFilter({
            name: "state",
            value: value
          });
        }
      }
    },
    dispatch
  );
};

const HomeWorkListStateDropdownContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(HomeWorkListStateDropdown);

export default HomeWorkListStateDropdownContainer;
